import { render, staticRenderFns } from "./ProfileReport.vue?vue&type=template&id=180ad6af&scoped=true"
import script from "./ProfileReport.vue?vue&type=script&lang=js"
export * from "./ProfileReport.vue?vue&type=script&lang=js"
import style0 from "./ProfileReport.vue?vue&type=style&index=0&id=180ad6af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180ad6af",
  null
  
)

export default component.exports